import type { SVGProps } from "react";
export interface ImageAIIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ImageAIIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ImageAIIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M12.66 11.265a2.13 2.13 0 0 1 2.681 0l.161.146 6.043 6.043.076.085a1.125 1.125 0 0 1-1.582 1.582l-.086-.076-5.954-5.955-2.997 2.999a2.125 2.125 0 0 1-2.843.145l-.161-.145-.498-.498-3.458 3.458a1.125 1.125 0 1 1-1.591-1.59l3.546-3.547.161-.147a2.13 2.13 0 0 1 2.684 0l.16.147.498.497 2.998-2.998zM9 6.875a2.126 2.126 0 1 1-2.114 2.342L6.875 9l.011-.218A2.125 2.125 0 0 1 9 6.875"
      />
      <path
        fill={color}
        d="M1.875 18V6A4.125 4.125 0 0 1 6 1.875h5.881a1.125 1.125 0 1 1 0 2.25H6c-1.036 0-1.875.84-1.875 1.875v12c0 1.036.84 1.875 1.875 1.875h12c1.035 0 1.875-.84 1.875-1.875v-5.88a1.125 1.125 0 0 1 2.25 0V18A4.125 4.125 0 0 1 18 22.125H6A4.125 4.125 0 0 1 1.875 18M18.5.875c.507 0 .951.34 1.085.83l.299 1.095c.174.64.675 1.14 1.315 1.315l1.097.3a1.126 1.126 0 0 1 0 2.17l-1.097.299a1.88 1.88 0 0 0-1.235 1.082l-.08.233-.299 1.097a1.126 1.126 0 0 1-2.17 0l-.3-1.097a1.88 1.88 0 0 0-1.082-1.235l-.233-.08-1.096-.299a1.125 1.125 0 0 1 0-2.17l1.096-.3.233-.08c.527-.222.93-.675 1.082-1.235l.3-1.096.064-.176a1.13 1.13 0 0 1 1.02-.653Zm0 4.039a4.3 4.3 0 0 1-.586.586q.322.262.585.585.264-.322.586-.585a4 4 0 0 1-.585-.586"
      />
    </svg>
  );
}
